import { pickList } from './pick-list';
import { DocumentType } from '../../../enums/document-type';

export const batchPickList = {
  ...pickList,
  id: DocumentType.BatchPickList.identifier,
};
